import { CommunicationService } from "@propertelligent/client-api";
import { saveRequestToken as saveOrgRequestToken } from "../../../my-organization/OrganizationEmail/organizationEmailApi";
import { ORG_GMAIL_OAUTH_STATE } from "../../../my-organization/OrganizationEmail/oauthRedirect";

/**
 * Pure dispatch logic for the shared /callback/gmail OAuth return route — extracted out of the
 * component (mirrors oauthRedirect.ts) so it's unit-testable without a DOM. Both the personal
 * (Messaging > Email) and organization (My Organization > Email) Gmail connections land here, since
 * they share the one redirect_uri Google has registered for this app's OAuth client; `state` (echoed
 * back unchanged by Google) says which flow this callback belongs to.
 */
export const handleGmailOAuthReturn = async (
  code: string | null,
  state: string | null,
  redirectUri: string
): Promise<string> => {
  const isOrgFlow = state === ORG_GMAIL_OAUTH_STATE;
  const fallbackRoute = isOrgFlow ? "/organization/email" : "/messaging/email";

  if (!code) {
    console.error("Code parameter not found in URL");
    return fallbackRoute;
  }

  if (isOrgFlow) {
    try {
      await saveOrgRequestToken(code, redirectUri);
    } catch (error) {
      console.error("Error making API call:", error);
    }
    return "/organization/email";
  }

  try {
    await CommunicationService.postApiGmailSaveRequestToken({
      authorizationToken: code,
      redirectUri,
    });
  } catch (error) {
    console.error("Error making API call:", error);
  }
  return "/messaging/email";
};
